import type {FeatureServiceBinder, Logger} from '@feature-hub/core';
import type {LocaleV3} from './create-binder-v3.js';
import {getCountryCode} from './get-country-code.js';
import {getCurrency} from './get-currency.js';
import {getLanguage} from './get-language.js';

export interface LocaleV1 {
  /**
   * ISO 3166-1 alpha-2
   */
  readonly countryCode: string;
  /**
   * ISO 639-1:2002
   */
  readonly language: string;
  /**
   * ISO 4217 alphabetic code
   */
  readonly currency: string;
}

export interface CreateBinderV1Options {
  readonly locale: LocaleV3;
  readonly logger: Logger;
}

export function createBinderV1(
  options: CreateBinderV1Options,
): FeatureServiceBinder<LocaleV1> {
  const {marketId, languageTag} = options.locale;

  const locale: LocaleV1 = {
    countryCode: getCountryCode(marketId),
    language: getLanguage(languageTag),
    currency: getCurrency(marketId),
  };

  return (consumerId, consumerName) => {
    options.logger.warn(
      `DEPRECATED: Version 1.0.0 of the locale service is deprecated. The consumer "${consumerId}"${
        consumerName ? ` ("${consumerName}")` : ``
      } should use 3.0.0 instead.`,
    );

    return {featureService: locale};
  };
}
